import {AppointmentStatus, IAppointmentCancellation, ICustomerReview} from "../client-site";

export enum CustomerTimelineType {
  HISTORY = 'history',
  FUTURE = 'future',
}

export interface ICustomerTimeline {
  appointmentId: string;
  servicesIds: string[];
  date: string;
  startHour: string;
  endHour: string;
  price: string;
  maxPrice: string;
  type: CustomerTimelineType;
  status: AppointmentStatus;
  images: Array<string>;
  provider: string;
  review?: ICustomerReview;
  adminNote?: string;
  customerNote?: string;
  paymentRequestId?: string;
  recurringManualEventId?: string;
  /** Present on cancelled visits: who cancelled, when, and why. */
  cancellation?: IAppointmentCancellation;
}
